import { ILeaderboardEntry } from "./leaderboard";
import { ITransaction } from "./transaction";

export enum UserRoles {
    END_USER = 'END_USER',
    DEVELOPER = 'DEVELOPER',
    ADMIN = 'ADMIN',
    SUPPORT = 'SUPPORT',
    BETA_TESTER = 'BETA_TESTER',
}


export enum AccountTier {
    FREE = 'free',
    PREMIUM = 'premium',
    FAMILY = 'family',
    UNLIMITED = 'unlimited',
}

export interface IUser {
    cognitoUserId: string;
    email: string;
    emailVerified: boolean;
    name?: string;
    firstName?: string;
    lastName?: string;
    username: string;
    dateOfBirth?: string;
    country?: string;
    city?: string;
    language?: string;
    role: UserRoles[];
    currency: number;
    accountTier: AccountTier;
    lastLoginAt?: string;
    lastActivityAt?: string;
    lastPasswordChangeAt?: string;
    developerId?: string;
    isProfileCompleted: boolean;
    avatarUrl?: string;
    avatarKey?: string;
    createdAt: string;
    updatedAt: string;
    deletedAt?: string;
}

export interface IUpdateUserRequest {
    name?: string;
    firstName?: string;
    lastName?: string;
    username?: string;
    country?: string;
    city?: string;
    language?: string;
    dateOfBirth?: string;
    accountTier?: AccountTier;
    role?: UserRoles[];
    developerId?: string;
    currency?: number;
}

export interface IUserSummary {
    user: IUser;
    transactions: { items: ITransaction[]; };
    topLeaderboards: { items: ILeaderboardEntry[]; };
}
